import { useTripFormPriceEstimateResult } from './useTripFormPriceEstimateResult';

export function TripPriceEstimateResult() {
  const formatted = useTripFormPriceEstimateResult();
  return (
    <div className="flex flex-col" data-testid="trip-price-estimate">
      <span className="whitespace-nowrap text-xs font-bold uppercase">
        Estimated Revenue
      </span>
      <span className="text-3xl font-bold">{formatted}</span>
    </div>
  );
}
